import React from "react";
import Seo from "../components/seo";
import Strings from "../utils/stringUtil";
import Intro from "../components/financialProducts/intro";
import LoanMerit from "../components/financialProducts/loanMerit";
import GetExpertEventAccess from "../components/financialProducts/getExpertEventAccess";
import AccessBenefitsDownloadApp from "../components/financialProducts/accessBenefitsDownloadApp";
import withLoader from "../components/ui/withLoader";
import { financialProductsSchemaMarkup } from "../utils/schemaUtil";

function FinancialProducts() {
  return (
    <React.Fragment>
      <Seo
        title={Strings.financialProductsMetaTitle}
        description={Strings.financialProductsMetaDescription}
        keywords={Strings.financialProductsMetaKeyword}
        schema={financialProductsSchemaMarkup}
      />
      <Intro />
      <LoanMerit />
      <GetExpertEventAccess />
      <AccessBenefitsDownloadApp />
    </React.Fragment>
  );
}

export default withLoader(FinancialProducts);

